var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2148 70.7721V62.145H89.3164V70.7721H95.393V48.1074H89.3148V56.7346H81.2148V48.1074H75.1367V70.7721H81.2148ZM115.313 70.7721V65.3586H104.073V62.145H113.626V56.7346H104.073V53.5194H115.315V48.1074H97.9961V70.7721H115.313ZM123.862 70.7721V62.6526H124.335C126.191 62.6526 127.035 63.2277 127.946 64.7159L131.693 70.7721H138.615L135.374 65.665C134.227 63.8704 133.213 62.4169 130.885 61.8417C134.732 61.5023 137.67 59.5741 137.67 55.2103C137.67 50.2053 133.888 48.1074 128.623 48.1074H117.787V70.7721H123.862ZM128.69 53.5194C130.412 53.5194 131.255 54.2297 131.255 55.6503C131.255 57.0379 130.412 57.7827 128.69 57.7827H123.862V53.5194H128.69ZM157.224 70.7721V65.3586H145.985V62.145H155.537V56.7346H145.985V53.5194H157.226V48.1074H139.907V70.7721H157.224ZM164.988 70.769V64.9861H158.912V70.769H164.988Z",
    fill: "#AAAAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.981 70.7672V64.9844H158.904V70.7672H164.981Z",
    fill: "#AAAAB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3883 71.2596L34.4461 71.2895L34.5117 71.2848L62.007 69.6128L59.5617 74.0332L31.818 75.7209L15.3398 67.5243L17.8289 63.0222L34.3883 71.2596ZM39.5164 52.3113L38.6273 48.0842L41.0023 43.6465L44.218 54.4406L39.5164 52.3113ZM35.5164 61.4319L24.9602 62.1626L16.8555 58.1901L19.3617 53.6612L36 61.4319H35.5164Z",
    fill: "#0B0B17",
    stroke: "#AAAAB6",
    strokeWidth: 0.466065
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4434 69.3371L34.5059 71.0374L17.5918 62.6774L35.9074 61.5649L19.2559 53.3353L27.434 46.3974L44.3934 54.7543L41.0684 43L57.2746 50.964L62.4434 69.3371Z",
    fill: "#AAAAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHere);
export default __webpack_public_path__ + "static/media/here.6f67ec0d82725112085fe12bf4b094fa.svg";
export { ForwardRef as ReactComponent };